import React, { Component } from "react";
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import { connect } from "react-redux";
import { Button } from "reactstrap";
import Select from "react-select";
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";
import DrawingManager from "react-google-maps/lib/components/drawing/DrawingManager";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";
import {
	setSelectedAreas,
	setMarkerData,
	hideInfoBox,
	loadWardData
} from "../../actions/mapActions";
import { setSelectedMapIcons } from "../../actions/filterActions";
import MapInfoBox from "./mapInfoBox";
import WardMapInfoBox from "./mapWardInfoBox";
import { loadDefaultStyle, changePoiStyles } from "./handleMapStyles";
import Filter from "./filter";
import { mapIconsText } from "../../../map_icons_text";
// import stategeoJson from "../../../../src/gadm36_IND_1.json";
// import wardJSON from "../../../../src/ward_data.json";
// import districtGeoJson from "../../../../src/gadm36_IND_3.json";
import _ from 'lodash';

const ValueRender = c1 => {
	if (c1.value === "hospital") {
		return (
			<div>
				<img
					alt={c1.value}
					height={20}
					width={20}
					src={`http://maps.gstatic.com/mapfiles/place_api/icons/doctor-71.png`}
				/>{" "}
				{c1.value}
			</div>
		);
	} else if(c1.value === "lakme_store") {
		return (
			<div>
				<img
					alt={c1.value}
					height={20}
					width={20}
					src={`https://s3-ap-southeast-1.amazonaws.com/locauditooh-images/lakme2.png`}
				/>{" "}
				{c1.value}
			</div>
		);
	}
	else if(c1.value === "olx_car_store") {
		return (
			<div>
				<img
					alt={c1.value}
					height={20}
					width={20}
					src={`https://s3-ap-southeast-1.amazonaws.com/locauditooh-images/olx_car.png`}
				/>{" "}
				{c1.value}
			</div>
		);
	}
	else if(c1.value === "one_plus_store") {
		return (
			<div>
				<img
					alt={c1.value}
					height={20}
					width={20}
					src={`https://locauditooh-images.s3-ap-southeast-1.amazonaws.com/one_plus_60x60.png`}
				/>{" "}
				{c1.value}
			</div>
		);
	} else {
		return (
			<div>
				<img
					alt={c1.value}
					height={20}
					width={20}
					src={`http://maps.gstatic.com/mapfiles/place_api/icons/${
						c1.value
					}-71.png`}
				/>{" "}
				{c1.value}
			</div>
		);
	}
};

class GoogleMaps extends Component {
	state = {
		// markerData : { site_code: "0047",  campaign_id: "5a33b218ccbce417e0fb1262", universal_unique_code: "CTIMESI07-399"},
		map_icons: mapIconsText,
		selectedAreas: [],
		poi_array: [
			{ label: "Tourist Attraction", value: "attraction", selected: false },
			{ label: "Businesses", value: "business", selected: false },
			{ label: "Government Buildings", value: "government", selected: false },
			{ label: "Emergency Services", value: "medical", selected: false },
			{ label: "Parks", value: "park", selected: false },
			{ label: "Place of Worship", value: "place_of_worship", selected: false },
			{ label: "School", value: "school", selected: false },
			{ label: "Sports Complex", value: "sports_complex", selected: false }
		],
		map: null,
		shape: null,
		loader:false,
		activeWardInfo:null,
		demographicType:'population'
	};

	componentDidMount() {
		let map = this._map.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
		loadDefaultStyle(map);

		map.controls[window.google.maps.ControlPosition.LEFT].push(this._filterDiv);
		map.controls[window.google.maps.ControlPosition.RIGHT].push(
			this._legendDiv
		);
		map.controls[window.google.maps.ControlPosition.TOP].push(
			this._clearMapDiv
		);

		console.log(map);
		this.setState({ map: map });
		
		this.props.loadWardData();
	}

	onMarkerClick = markerData => {
		this.props.setMarkerData(markerData);
	};

	onCircleComplete = circle => {
		let { selectedAreas } = this.state;
		let { setSelectedAreas, selectedMapIcons } = this.props;
		this.setState({ drawingMode: null, markerItem: null, shape: circle });
		selectedAreas = selectedAreas.concat(circle);
		this.setState({ selectedAreas: selectedAreas }, () => {
			setSelectedAreas(selectedMapIcons, selectedAreas);
		});
	};

	onInfoBoxCloseClick = () => {
		this.props.hideInfoBox();
		this.setState({activeWardInfo:null})
	};

	handlePoiClicked = poi_item => {
		let { poi_array, map } = this.state;

		poi_array = poi_array.map(item => {
			let temp_poi_item = item;
			if (poi_item.value === item.value) {
				poi_item.selected = !poi_item.selected;
			}
			return temp_poi_item;
		});

		this.setState({ poi_array: poi_array });

		changePoiStyles(map, poi_item);
	};

	hanldeShapeClearButton = () => {
		let { shape } = this.state;
		if (shape) {
			shape.setMap(null);
			this.setState({ shape: null });
		}
	};

	handleMapIconsChange = selectedMapIcons => {
		const { setSelectedMapIcons, selectedAreas } = this.props;
		setSelectedMapIcons(selectedMapIcons, selectedAreas);
	};

	prepareMapIconsOptions = () => {
		const { map_icons } = this.state;
		return map_icons.map(item => {
			return { value: item[0], label: item[0] };
		});
	};

	// drawShapeCity = (selectedFiletrValues) => {
	// 	if(this.state.map){
	// 		console.log('gejson',stategeoJson,'   filtervalues',selectedFiletrValues)
	// 		if(selectedFiletrValues.city && selectedFiletrValues.city.length>0 && _.findIndex(selectedFiletrValues.city, (s) => s.value==="Delhi")!==-1){
	// 			const selectedShape = _.filter(stategeoJson.features, (f) => f.properties["NAME_1"]==="NCT of Delhi");
	// 			const finalData = {type:"FeatureCollection", features:selectedShape};
	// 			console.log("finalData",finalData);
	// 			this.state.map.data.addGeoJson(finalData);
	// 			this.state.map.data.setStyle({
	// 				fillColor: 'green',
	// 				strokeWeight: 1
	// 			  });
	// 			this.zoom();
	// 		}
	// 	}
	// }



	drawWardShape = (demographic_type) => {

		if(this.state.map && this.props.cityWardData){
			// const selectedShape =[];
				//  _.map(wardJSON.features, (f,i) => { if(i<5){ selectedShape.push(f)}});
				const selectedShape = _.filter(this.props.cityWardData.features,(f,i) => {
					 return f.properties.total_population>0;
				 })
				const finalData = {type:"FeatureCollection", features:selectedShape};
				console.log("finalData",finalData);
				
				/* --- Removing Layer -----*/
				if(this.state.map.data){
					const that = this;
					this.state.map.data.forEach(function(feature) {
						// filter...
						that.state.map.data.remove(feature);
					});
					
				}

				/*---- Adding Layer ----*/
				this.state.map.data.addGeoJson(finalData);

				/* --- Setting Style -- -*/
				if(demographic_type==='population'){
					var max_population_doc = _.maxBy(selectedShape, function(o) { return o.properties.total_population; });
					var max_population = max_population_doc.properties.total_population;

					this.state.map.data.setStyle(function(feature){
						var total_population = feature.getProperty('total_population');
						
						var population_density=0;
							population_density = (total_population/ max_population)
						var color = "#f51500";
						return {
							fillColor: color,
							fillOpacity:population_density,
							strokeWeight: 1,
							strokeColor:color
						  }
					});
				}

				if(demographic_type==='employment'){
					var max_employment_doc = _.maxBy(selectedShape, function(o) { return o.properties.employment; });
					var max_employment = max_employment_doc.properties.employment;
					var min_employment_doc = _.minBy(selectedShape, function(o) { return  o.properties.employment; });
					var min_employment = min_employment_doc.properties.employment;
					console.log('max',max_employment, 'min',min_employment)
					this.state.map.data.setStyle(function(feature){
						var total_employment = feature.getProperty('employment');
						var employment=0;
							employment = ((total_employment-min_employment)/ (max_employment-min_employment))
						var color = "#e91e63";
						return {
							fillColor: color,
							fillOpacity:employment,
							strokeWeight: 1,
							strokeColor:color
						  }
					});
				}

				if(demographic_type==='literacy'){
					var max_literacy_doc = _.maxBy(selectedShape, function(o) { return o.properties.literacy; });
					var max_literacy = max_literacy_doc.properties.literacy;
					var min_literacy_doc = _.minBy(selectedShape, function(o) { return  o.properties.literacy; });
					var min_literacy = min_literacy_doc.properties.literacy;
					console.log('max2',max_literacy)
					this.state.map.data.setStyle(function(feature){
						var total_literacy = feature.getProperty('literacy');
						var literacy=0;
							literacy = ((total_literacy-min_literacy)/ (max_literacy-min_literacy))
						var color = "#2E375F";
						return {
							fillColor: color,
							fillOpacity:literacy,
							strokeWeight: 1,
							strokeColor:color
						  }
					});
				}
				

				/* Set Mouseover event */
				
				//  this.state.map.data.addListener('mouseover', function(event) {
				// 	// console.log('population',event.feature.getProperty('total_population'));
				// 	that.state.map.infoWindow = new window.google.maps.InfoWindow({
				// 		content: '<span>hola mofo !</span>',
				// 	});
				// 	that.state.map.infoWindow.open(that.state.map);
				//   });

				  /* Set Click event */
				  var that = this;
				 this.state.map.data.addListener('click', function(event) {
						console.log('Twaadi maa di', event.feature.l)

						that.setState({activeWardInfo: event.feature.l })
				  })


				this.setState({demographicType:demographic_type})
				this.zoom();
		}	
	}

	
	// var polygon = new google.maps.Polygon(/* omitted for brevity */);
	// attachPolygonInfoWindow(polygon, '<strong>Info about this area</strong>');

	

	zoom = () => {
		function processPoints(geometry, callback, thisArg) {
			if (geometry instanceof window.google.maps.LatLng) {
			  callback.call(thisArg, geometry);
			} else if (geometry instanceof window.google.maps.Data.Point) {
			  callback.call(thisArg, geometry.get());
			} else {
			  geometry.getArray().forEach(function(g) {
				processPoints(g, callback, thisArg);
			  });
			}
		  }

		var bounds = new window.google.maps.LatLngBounds();
        this.state.map.data.forEach(function(feature) {
          processPoints(feature.getGeometry(), bounds.extend, bounds);
        });
        this.state.map.fitBounds(bounds);
	  }
	  
	 

	render() {
		
		let { poi_array, shape } = this.state;
		const {
			searchData,
			set_marker_data,
			center,
			selectedMapIcons,
			poi_markers
		} = this.props;
		console.log('searchData',searchData)
		let maps = window.google.maps;

		//Setting InfoBox
		let show_info_box = set_marker_data.site_code ? true : false;
		let info_box_latitude, info_box_longitude;
		if (show_info_box) {
			info_box_latitude = set_marker_data.latitude;
			info_box_longitude = set_marker_data.longitude;

			if (show_info_box.photos) {
				info_box_latitude =
					set_marker_data.photos.length > 0
						? set_marker_data.photos[set_marker_data.photos.length - 1].latitude
						: set_marker_data.latitude;
				info_box_longitude =
					set_marker_data.photos.length > 0
						? set_marker_data.photos[set_marker_data.photos.length - 1]
								.longitude
						: set_marker_data.longitude;
			}
		}

		let show_ward_info_box = this.state.activeWardInfo ? true :false;
		if(show_ward_info_box){
			info_box_latitude = this.state.activeWardInfo.latitude;
			info_box_longitude = this.state.activeWardInfo.longitude;
		}

		//Fit marker in bounds

		// if (window.google && this.state.map && searchData.length!==0) {
		// 	let markerBounds = new window.google.maps.LatLngBounds();
		// 	for (let i = 0; i < searchData.length; i++) {
		// 		let item = searchData[i];
		// 		let position = new window.google.maps.LatLng(
		// 			parseFloat(item.latitude),
		// 			parseFloat(item.longitude)
		// 		);
		// 		markerBounds.extend(position);
		// 	}

		// 	this.state.map.fitBounds(markerBounds);
			
		// }

		//console.log('','activeWard',this.state.activeWardInfo, 'info_box_latitude',info_box_latitude,'info_box_longitude',info_box_longitude)
		

		return (
			<GoogleMap
				defaultZoom={6}
				defaultCenter={center}
				ref={map => (this._map = map)}
			>	
				
				 {/* //----- Loader ------// */}
					<div className="loader-box" style={{position:"absolute", top:"0", background:"#00000066", height:"100%", width:"100%", display:this.props.loaderState? "block":"none"}}>
						<img style={{display:"block", marginLeft:"auto", marginRight:"auto", marginTop:"10%", height:"100px", width:"100px"}}
									 src="https://locauditooh-images.s3-ap-southeast-1.amazonaws.com/loader3.gif"
									 alt="Loader" />
					</div>
					

{/* 
				<div
					ref={legendDiv => (this._legendDiv = legendDiv)}
					id="legend"
					className=""
				>
					{poi_array.map((item, key) => {
						const { selected } = item;

						return (
							<div
								className={
									selected
										? "bg-success p-2 m-1 text-light"
										: "bg-warning p-2 m-1 text-dark"
								}
								key={key}
								onClick={this.handlePoiClicked.bind(this, item)}
							>
								{item.label}
							</div>
						);
					})}
				</div> */}
				
				
				

				<div
					ref={filterDiv => (this._filterDiv = filterDiv)}
					id="filterDiv"
					className=""
				>
					<Filter 
						// drawShapeCity = {this.drawShapeCity.bind(this)} 
						drawWardShape = {this.drawWardShape.bind(this)}
					/>
					
				</div>

				<div
					style={{ width: 300 }}
					ref={clearMapDiv => (this._clearMapDiv = clearMapDiv)}
					id="clearMapDiv"
					className=""
				>
					<div className="row m-2">
						{shape && (
							<div className="col-md-2">
								<Button block onClick={this.hanldeShapeClearButton.bind(this)}>
									X{" "}
								</Button>
							</div>
						)}
						<div className="col">
							<Select
								valueRenderer={ValueRender}
								optionRenderer={ValueRender}
								placeholder="Select point of interest"
								value={selectedMapIcons}
								onChange={this.handleMapIconsChange}
								multi
								options={this.prepareMapIconsOptions()}
							/>
						</div>
					</div>
				</div>

				{show_info_box && (
					<InfoBox
						position={
							new maps.LatLng(
								parseFloat(info_box_latitude),
								parseFloat(info_box_longitude)
							)
						}
						options={{ enableEventPropagation: true }}
						onCloseClick={this.onInfoBoxCloseClick.bind(this)}
					>
						<MapInfoBox set_marker_data={this.props.set_marker_data} />
					</InfoBox>
				)}

				{
					show_ward_info_box && (
						<InfoBox
						position={
							new maps.LatLng(
								parseFloat(info_box_latitude),
								parseFloat(info_box_longitude)
							)
						}
						options={{ enableEventPropagation: true }}
						onCloseClick={this.onInfoBoxCloseClick.bind(this)}
					>
						<WardMapInfoBox ward_info={this.state.activeWardInfo} demographic_type = {this.state.demographicType}/>
					</InfoBox>
					
				)}

				{/* {
					show_ward_info_tooltip && (
						<InfoBox
						position={
							new maps.LatLng(
								parseFloat(info_box_latitude),
								parseFloat(info_box_longitude)
							)
						}
						options={{ enableEventPropagation: true }}
						onCloseClick={this.onInfoBoxCloseClick.bind(this)}
					>
						<span></span>
					</InfoBox>
					
				)} */}


				{/* <TrafficLayer autoUpdate /> */}

				{/* cluster for sites */}
				{
					searchData && searchData.length>0 && 
					<MarkerClusterer minimumClusterSize={10} >
					{searchData.map((item, index) => {
						let position = {
							lat: parseFloat(item.latitude),
							lng: parseFloat(item.longitude)
						};
						return (
							<Marker
								key={index}
								position={position}
								title={item.name || item.site_code}
								onClick={this.onMarkerClick.bind(this, item)}
								icon={{
									url: item.icon? item.icon:"https://s3-ap-southeast-1.amazonaws.com/screenodata/icons/new_2.png"
										
								}}
							/>
						);
					})}
				</MarkerClusterer>
				}


				{/* POI Markers */}

				{poi_markers.map((item, index) => {
					let position = {
						lat: item.geometry.location.lat,
						lng: item.geometry.location.lng
					};
					return (
						<Marker
							key={index}
							position={position}
							icon={{
								url: item.icon,
								scaledSize: new window.google.maps.Size(30, 30)
							}}
							title={item.name}
						/>
					);
				})}

				<DrawingManager
					onCircleComplete={this.onCircleComplete}
					options={{
						drawingMode: this.state.drawingMode,
						drawingControl: true,
						drawingControlOptions: {
							position: window.google.maps.ControlPosition.TOP_CENTER,
							drawingModes: [window.google.maps.drawing.OverlayType.CIRCLE]
						},
						circleOptions: {
							clickable: false,
							editable: false
						}
					}}
				/>

				
			</GoogleMap>
		);
	}
}

const mapStateToProps = state => {
	console.log('state',state)
	return {
		searchData: state.filter.searchData,
		selectedMapIcons: state.filter.selectedMapIcons,
		poi_markers: state.map.poi_markers,
		set_marker_data: state.map.set_marker_data,
		selectedAreas: state.map.selectedAreas,
		loaderState:state.filter.loaderState,
		cityWardData : state.map.ward_data
	};
};

export default connect(
	mapStateToProps,
	{ setSelectedAreas, setMarkerData, hideInfoBox, setSelectedMapIcons , loadWardData}
)(withGoogleMap(GoogleMaps));



// WEBPACK FOOTER //
// ./src/v3/components/createCampaign/googleMap.js